import React from 'react';

const Footer = () => {
  return (
    <footer className="footer" data-reveal>
      <div className="container footer-inner">
        <p>&copy; {new Date().getFullYear()} David Jhay. All rights reserved.</p>
        <a className="btn btn-ghost small" href="#top">Back to top</a>
      </div>
    </footer>
  );
};

export default Footer;
